<!--
 * @Author: yeqing
 * @Date: 2021-11-24 09:46:07
 * @LastEditTime: 2021-11-30 17:12:36
 * @LastEditors: Please set LastEditors
 * @Description: 小巨人测评
 * @FilePath: \fe-frame-page\src\views\enterpriseSpecial\littleGiant\index.vue
-->
<template>
	<div class="smEvaluation">
		<a-tabs>
			<a-tab-pane tab="专精特新测评" key="evaluation"></a-tab-pane>
		</a-tabs>
		<div class="page-title">
			<span></span>专精特新小巨人企业测评
		</div>
		<div class="tips">
			<span>*</span>温馨提示：为保证结果的准确性，请如实填写。
		</div>
		<div class="menu-title-box">
			<div :class="tabKey == 1 ? 'active' : 'pass'">
				<div class="before"></div>
				<div class="text">企业基本信息</div>
				<div class="after"></div>
			</div>
			<div :class="tabKey == 2 ? 'active' : tabKey > 2 ? 'pass' : ''">
				<div class="before"></div>
				<div class="text">创新能力</div>
				<div class="after"></div>
			</div>
			<div :class="tabKey == 3 ? 'active' : tabKey > 3 ? 'pass' : ''">
				<div class="before"></div>
				<div class="text">经济效益</div>
				<div class="after"></div>
			</div>
			<div :class="tabKey == 4 ? 'active' : tabKey > 4 ? 'pass' : ''">
				<div class="before"></div>
				<div class="text">获取结果报告</div>
				<div class="after"></div>
			</div>
		</div>
		<div>
			<div v-show="tabKey == 1">
				<div class="page-title">
					<span></span>企业基本信息
				</div>
				<basicInfoModel @changeTabKey="changeTabKey"></basicInfoModel>
			</div>
			<div v-show="tabKey == 2">
				<div class="page-title">
					<span></span>创新能力测评
				</div>
				<innovationModel @changeTabKey="changeTabKey"></innovationModel>
			</div>
			<div v-show="tabKey == 3">
				<div class="page-title">
					<span></span>经济效益测评
				</div>
				<economicBenefitModel @changeTabKey="changeTabKey" @handleSubmit="handleSubmit" :loading="loading"></economicBenefitModel>
			</div>
			<div v-show="tabKey == 4">
				<div class="page-title">
					<span></span>获取结果报告
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import basicInfoModel from "./components/basicInfoModel";
import innovationModel from "./components/innovationModel";
import economicBenefitModel from "./components/economicBenefitModel";
import { littleGiantEva } from "@/api/enterpriseSpecial"

export default {
	name: "smEvaluation",
	components: {
		basicInfoModel,
		innovationModel,
		economicBenefitModel,
	},
	data() {
		return {
			tabKey: 1,
			basicInfo: {}, // 基本信息
			economicBenefit: {}, // 经济效益
			innovation: {}, // 创新能力
			loading:false, //按钮loading
		};
	},
	created() { },
	methods: {
		changeTabKey(e) {
			if (e.key > this.tabKey) {
			    let result = this.isEmpty(e.data)
			    if (!result) return
			}
			this.tabKey = e.key;
			this[e.name] = e.data;
		},

		// 是否有空值
		isEmpty(data) {
			let falg = true;
			for (const key in data) {
				const element = data[key];
				if (!element && element !== 0) {
					falg = false;
				}
			}
			if (!falg) {
				this.$message.error('您有未填写的企业信息，请补全完成');
			}
			return falg;
		},

		// 点击立即测评
		handleSubmit(e) {
			this.economicBenefit = e;
			let result = this.isEmpty(e)
			if (!result) return
			this.loading = true
			let data = [];
			let info = {
				...this.basicInfo,
				...this.innovation,
				...this.economicBenefit,
			};
			for (const key in info) {
				let soure = key.substr(1)
				soure = soure.slice(0, 1) + '-' + soure.slice(1)
				soure = soure.slice(0, 3) + '-' + soure.slice(3)
				data.push({
					code: soure,
					content: info[key],
				});
			}
			littleGiantEva(data).then(res => {
				sessionStorage.setItem('resultData',JSON.stringify(res.data))
				this.$router.push("/enterpriseSpecial/littleGiant/result")
				this.loading = false
			}).catch(()=>{
				this.loading = false
			})
		},
	},
};
</script>
<style lang="less" scoped>
.smEvaluation {
	padding: 0px 20px 20px 20px;
	background: #fff;
	::v-deep .ant-tabs-tab-active {
		font-weight: 500;
		color: #333;
		font-size: 16px;
		padding: 15px 0 17px 0;
	}
	::v-deep .ant-tabs-ink-bar {
		width: 100px !important;
		background: #0072f7;
	}
	.page-title {
		> span {
			display: inline-block;
			width: 3px;
			height: 14px;
			background: #0072f7;
			margin-right: 9px;
		}
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: bold;
		color: #333333;
		line-height: 16px;
		margin-top: 20px;
	}
	.tips {
		> span {
			font-size: 14px;
			line-height: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #ff4d4f;
		}
		width: 706px;
		height: 14px;
		line-height: 14px;
		color: #999999;
		margin-top: 14px;
	}
	.desc {
		width: 100%;
		padding: 20px 20px 10px 20px;
		background: #fafafa;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 16px;
		margin-top: 20px;
		> div {
			margin-bottom: 10px;
		}
	}
	.menu-title-box {
		display: flex;
		margin: 20px 0 40px 0;
		> div {
			flex: 1;
			height: 36px;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
			text-align: center;
			line-height: 36px;
			margin-right: -8px;
			position: relative;
			display: flex;
			.before {
				width: 36px;
				height: 36px;
				background: #f3f5f7;
				clip-path: polygon(
					0 0,
					100% 0,
					100% 50%,
					100% 100%,
					0 100%,
					50% 50%
				);
			}
			.after {
				width: 36px;
				height: 36px;
				background: #f3f5f7;
				clip-path: polygon(
					0 0,
					50% 0,
					100% 50%,
					50% 100%,
					0 100%,
					0% 50%
				);
				margin-left: -1px;
			}

			.text {
				flex: 1;
				background: #f3f5f7;
				margin-left: -1px;
			}
			&:first-child {
				.before {
					clip-path: polygon(
						0 0,
						100% 0,
						100% 50%,
						100% 100%,
						0 100%,
						0% 50%
					);
				}
			}
			&:last-child {
				.after {
					clip-path: polygon(
						0 0,
						100% 0,
						100% 100%,
						50% 100%,
						0 100%,
						0% 50%
					);
				}
			}
			&::before {
				display: block;
				content: "";
				width: 36px;
				height: 36px;
				position: absolute;
				left: 0;
				clip-path: polygon(
					0 0,
					90% 0,
					100% 50%,
					90% 100%,
					0 100%,
					10% 50%
				);
				-webkit-clip-path: polygon(
					0 0,
					90% 0,
					100% 50%,
					90% 100%,
					0 100%,
					10% 50%
				);
				// background: linear-gradient(45deg, transparent 15%, #F3F5F7 0), linear-gradient(135deg, transparent 15%, #F3F5F7 0) !important;
			}
		}
		.pass {
			.before,
			.text,
			.after {
				background: #F0F5FE;
				color: #0072f7;
			}
		}
		.active {
			.before,
			.text,
			.after {
				background: #0072f7;
			}
			// background: #0072f7;
			color: #fff;
			// &::before {
			// 	background: #0072f7 !important;
			// }
		}
	}
}

/deep/.ant-form-item-control-wrapper {
	display: inline-block;
}
/deep/.ant-form-item-label {
	// font-family: PingFangSC-Regular, PingFang SC;
	color: #333333;
	margin-right: 6px;
}
/deep/.ant-form-item {
	margin-bottom: 20px;
}
/deep/.ant-input {
	border-radius: 2px;
	border: 1px solid #e0e0e0;
}
/deep/span.ant-radio + * {
	padding-right: 36px;
}
</style>